/**
 * 应用根组件
 */
import { AppProviders } from './providers';
import { Router } from './Router';
import '@/lib/i18n';
import { Toaster } from '@/components/ui/toaster';
import { ImageEditTaskCoordinator } from '@/components/features/preview/ImageEditTaskCoordinator';
import { ImageUpscaleTaskCoordinator } from '@/components/features/preview/ImageUpscaleTaskCoordinator';

export function App() {
  return (
    <AppProviders>
      <Router />
      <ImageEditTaskCoordinator />
      <ImageUpscaleTaskCoordinator />
      <Toaster />
    </AppProviders>
  );
}
